'use es6';

import tinymce from 'tinymce';
import { __HS_FIND_REPLACE } from '../constants/plugins';
import { handleOnOpen, getHandleFind, getHandleFindPrev, getHandleFindNext, getHandleToggleShowReplace, getHandleReplaceAll, getHandleDone } from './handlers';
import FindReplacePopover from '../components/FindReplacePopover';
import { jsx as _jsx } from "react/jsx-runtime";
export const HS_FIND_REPLACE = __HS_FIND_REPLACE;
function findReplacePlugin(editor) {
  const searchReplaceApi = editor.plugins.searchreplace;
  const findReplaceProps = {
    onFind: getHandleFind(searchReplaceApi),
    onFindNext: getHandleFindNext(searchReplaceApi),
    onFindPrev: getHandleFindPrev(searchReplaceApi),
    onToggleShowReplace: getHandleToggleShowReplace(editor),
    onReplaceAll: getHandleReplaceAll(editor, searchReplaceApi),
    onDone: getHandleDone(searchReplaceApi)
  };
  tinymce.canvas.addToolbarPopover(editor, HS_FIND_REPLACE, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(FindReplacePopover, Object.assign({
        editor: editor
      }, findReplaceProps, renderProps));
    }
  });
  editor.shortcuts.add('Meta+F', '', () => {
    editor.fire('OpenFindReplace');
    handleOnOpen(editor);
  });
}
tinymce.PluginManager.add(HS_FIND_REPLACE, findReplacePlugin);